import services from '@/config/services'

/**
 * Italian message for a start error.
 * The server's text is shown only if it comes from the impersonation endpoint ({ success: false, message }),
 * not the framework's generic messages (in English).
 */
function errorMessage(status, data) {
  if (status === 401) {
    return 'Sessione di ASK Admin scaduta: esci e accedi di nuovo.'
  }
  if (status === 429) {
    return 'Troppe richieste in poco tempo: attendi un minuto e riprova.'
  }
  if (data && data.success === false && typeof data.message === 'string' && data.message !== '') {
    return data.message
  }
  return 'Impossibile avviare la sessione. Riprova.'
}

export default class ImpersonationService {
  constructor(http, eventBus) {
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  /**
   * Asks ask_api for a one-time access link (valid for 60 seconds).
   * Does not emit 'data-load-error', so the global toast does not overlap the component's one.
   */
  async start(targetType, targetId, email) {
    const url = `${this.baseUrl}/impersonation`
    try {
      const res = await this.http.post(url, {
        target_type: targetType,
        target_id: targetId,
        email: email,
      })
      return {
        success: res.data && res.data.success === true,
        url: res.data && res.data.data ? res.data.data.url : null,
        message: res.data ? res.data.message : null,
      }
    } catch (err) {
      const response = err && err.response ? err.response : null
      return {
        success: false,
        url: null,
        message: errorMessage(response ? response.status : 0, response ? response.data : null),
      }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }
}
